// All public endpoint paths used by the front-end.
// Mirrors backend routes in evoluxu/server/.

export const EP = {
  // Public content
  siteContent:    '/api/site-content',
  pages:          '/api/pages',
  page:           (slug) => `/api/pages/${encodeURIComponent(slug)}`,
  legal:          (type) => `/api/legal/${encodeURIComponent(type)}`,
  categories:     '/api/categories',
  products:       '/api/products',
  publicSettings: '/api/settings/public',
  currencies:     '/api/currencies',

  // ARK / game
  arkStatus:               '/api/ark/status',
  arkItems:                '/api/ark/items',
  arkCreatures:            '/api/ark/creatures',
  arkCreatureCategories:   '/api/ark/creature-categories',
  arkBundles:              '/api/ark/bundles',
  arkSaddleMap:            '/api/ark/saddle-map',

  // Auth
  authUser:           '/api/auth/user',
  authRegister:       '/api/auth/register',
  authEmailLogin:     '/api/auth/email-login',
  authForgot:         '/api/auth/forgot-password',
  authReset:          '/api/auth/reset-password',
  authVerifyEmail:    '/api/auth/verify-email',
  authSendVerify:     '/api/auth/send-verification',
  authVerificationStatus: '/api/auth/verification-status',
  authLogout:         '/api/auth/logout',
  authDelete:         '/api/auth/delete-account',
  authSteam:          '/api/auth/steam',
  authSteamReturn:    '/api/auth/steam/return',

  // User
  userOrders:        '/api/user/orders',
  userTransactions:  '/api/user/transactions',
  userPayoutInfo:    '/api/user/payout-info',
  userName:          '/api/user/name',
  userInventory:     '/api/user/inventory',
  userInventoryRm:   '/api/user/inventory/remove',
  userWithdraw:      '/api/user/withdraw',
  userWithdrawals:   '/api/user/withdrawals',
  userDeliveries:    '/api/user/deliveries',

  // Trading
  tradingListings:   '/api/trading/listings',
  tradingList:       '/api/trading/list',
  tradingBuy:        (id) => `/api/trading/buy/${encodeURIComponent(id)}`,
  tradingCancel:     (id) => `/api/trading/cancel/${encodeURIComponent(id)}`,
  tradingMyListings: '/api/trading/my-listings',

  // Shop / payments
  shopPurchase:      '/api/shop/purchase',
  paymentsMethods:        '/api/payments/methods',
  paymentsCheckoutMethods:'/api/payments/checkout-methods',
  paymentsFooter:         '/api/payments/footer',
  paymentsPackages:  '/api/payments/packages',
  paymentsConfig:    '/api/payments/config',
  paymentsInitiate:  '/api/payments/initiate',
  paymentsStatus:    (id) => `/api/payments/status/${encodeURIComponent(id)}`,
  paymentsHistory:   '/api/payments/history',

  // Public reference data
  countries:         '/api/countries'
}
